/* eslint-disable arrow-parens */
/* eslint-disable */
import { Box, Tabs, Tab, IconButton, SpeedDialAction, SpeedDial, Chip, Tooltip } from "@mui/material";
import { useEffect } from "react";
import { useContext } from "react";
import { useCallback, useMemo, useState } from "react";
import Fab from "@mui/material/Fab";

import Draggable from "react-draggable";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import {
	ActiveEnrollmentStatus,
	ActiveEnrollmentStatusV2,
	EnrollmentSchema,
	EnrollmentStatus,
	EnrollmentStatusV2,
	NextCurrentPlanOpenEnrollment,
	OpenEnrollmentByPlan,
	OpenEnrollmentByPlanV2,
	PlanNavigationMap,
	Status,
	VEBEnrollmentStatus
} from "../../../types/enrollment.types";
import { OverallPremiums } from "../../../types/overallPremiums.types";
import { GroupEnrollmentContext, PaycheckContext, ThemeContext, AuthContext, EligibleDependentContext } from "../../../contexts";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {
	HealthPlanBrochure,
	HelpingOurOwnPlanBrochure,
	KSOPPlanBrochure,
	GSTDPlanBrochure,
	ClinicCardPlanBrochure,
	GLTDClass1PlanBrochure,
	GLTDClass2PlanBrochure,
	GLIPlanBrochure
} from "../../../assets";
import Slide from "@mui/material/Slide";

import "./dynamicEnrollment.css";

import SpeedDialIcon from "@mui/material/SpeedDialIcon";
import EnrollmentTabLabel from "./enrollmentTabLabel/EnrollmentTabLabel";
import HealthPlanBranding from "./plans/healthPlan/branding/Branding";
// import HealthPlanForm from "./plans/healthPlan/form/HealthPlanForm";
import ClinicCardForm from "./plans/clinicCard/form/ClinicCardForm";
import ClinicCardBranding from "./plans/clinicCard/branding/Branding";
import KsopForm from "./plans/ksop/form/KsopForm";
import KsopBranding from "./plans/ksop/branding/KsopBranding";
import PDForm from "./plans/pd/PDForm";
import GltdForm from "./plans/GLTDClass1/form/GltdForm";
import GltdBranding from "./plans/GLTDClass1/branding/GltdBranding";
import GstdForm from "./plans/gstd/form/GstdForm";
import GstdBranding from "./plans/gstd/branding/GstdBranding";
import CceForm from "./plans/cce/form/CceForm";
import DownloadIcon from "@mui/icons-material/Download";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import EmailIcon from "@mui/icons-material/Email";

import { api } from "../../../utils/api";
import { Member } from "../../../types/employee.types";
import { Plan } from "../../../types/plan.types";
import { OpenEnrollment } from "../../../types/openEnrollment.types";
import { Plans, PlanTab } from "../../../types/components/enrollmentProps.types";
import { numberToDollarStr } from "../../../utils/commonFunctions/dollar";
import EnrollmentAcknowledgement from "./enrollmentAcknowledgement/EnrollmentAcknowledgement";
import { Brochure } from "../../../assets";
import downloadFile, { downloadBrochureFile } from "../../../utils/commonFunctions/downloadFile";
import PlanAcknowledgement from "./plans/planAknowledgement/PlanAknowledgement";
import { CCeBranding, GliBranding, HOOBranding } from "..";
import GLTDClass2Branding from "./plans/GLTDClass2/branding/GlassClass2Branding";
import GLIForm from "./plans/gli/GLIForm/GLIForm";
import LincolnForm from "./plans/GLTDClass2/form/LincolnForm";
import { trackPromise } from "react-promise-tracker";
import initCapitalize from "../../../utils/commonFunctions/initCapitalize";
import { dollarize } from "../../../utils/commonFunctions/dollarize";
import {
	buttonCaptionShortNames,
	coreEnrollmentArray,
	coreEnrollmentNext
} from "../../../constants/coreEnrollmentNext";
import { PLAN_NAME } from "../../../constants/plan";
import GLIFormv2 from "./plans/gli/GLIFormV2/GLIFormv2";
import PlanAcknowledgement2 from "./plans/planAknowledgement/AlwaysOpenPlanAcknowledgement";
import AlwaysOpenPlanAcknowledgement from "./plans/planAknowledgement/AlwaysOpenPlanAcknowledgement";
import { ALL_PLANS } from "../../../constants/allPlan";
// import DynamicEnrollmentPlanForm from "./plans/DynamicEnrollmentPlanForm";
import DynamicPlanBranding from "./dynamicEnrollment/enrollmentBranding/DynamicPlanBranding";
import DynamicEnrollmentPlanForm from "./dynamicEnrollment/enrollmentForm/DynamicEnrollmentPlanForm";
import { toVEBPlanShape } from "../../../utils/commonFunctions/coreToVEBAdapter";
import CommonForm from "../VEBEnrollment/CommonForm";
import DifferenceIcon from "@mui/icons-material/Difference";
import EligiblityDialog from "../VEBEnrollment/eligiblityDialogs/EligiblityDialog";
// import DynamicEnrollmentPlanForm from "./dynamicEnrollment/enrollmentForm/EnrollmentPlanForm";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.action.hover
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14
	}
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(even)": {
		backgroundColor: theme.palette.action.hover
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0
	}
}));

function a11yProps(index: number) {
	return {
		id: `vertical-tab-${index}`,
		"aria-controls": `vertical-tabpanel-${index}`
	};
}

type ButtonCaption = {
	nextPlan: string;
	prevPlan: string;
};

type CoreButtonCaption = {
	"Health Plan": ButtonCaption;
	"Clinic Card": ButtonCaption;
	"Group Short Term Disability": ButtonCaption;
	"Group Long Term Disability(Class 1)": ButtonCaption;
	"Group Long Term Disability(Class 2)": ButtonCaption;
	KSOP: ButtonCaption;
	"Helping Our Own": ButtonCaption;
	"Christmas Club Election": ButtonCaption;
	"Group Life Insurance": ButtonCaption;
};
interface DynamicEnrollmentProps {
	onInitComplete?: () => void;
}

const DynamicEnrollment = ({ onInitComplete }: DynamicEnrollmentProps): JSX.Element => {
	const [activeTab, setActiveTab] = useState<string>();
	const [visitedPlans, setVisitedPlans] = useState<string[]>([]);
	const [activeEnrollmentStatus, setActiveEnrollmentStatus] = useState<ActiveEnrollmentStatusV2>();
	const [nextOfCurrentPlan, setNextOfCurrentPlan] = useState<NextCurrentPlanOpenEnrollment>();
	const [enrollments, setEnrollments] = useState<EnrollmentSchema[]>([]);
	const [activeEnrollments, setActiveEnrollments] = useState<EnrollmentStatus[]>([]);
	const [VEBEnrollmentStatus, setVEBEnrollmentStatus] = useState<VEBEnrollmentStatus | null>(null);
	const [openEnrollmentByPlan, setOpenEnrollmentByPlan] = useState<OpenEnrollmentByPlanV2 | null>(null);
	const [hasSetPlanTabs, setHasSetPlanTabs] = useState<boolean>(false);
	const { currentEnrollment, deleteCurrentEnrollment } = useContext(GroupEnrollmentContext);
	const [corePlansForEmployeeClassSpecific, setCorePlansForEmployeeClassSpecific] = useState<Plan[]>([]);
	const [planTabs, setPlanTabs] = useState<PlanTab[]>([]);
	const [sortedPlans, setSortedPlans] = useState<Plan[]>([]);
	const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
	const [togglePlan, setTogglePlan] = useState(false);
	const [width, setWidth] = useState<number>(window.innerWidth);

	const [openEnrollments, setOpenEnrollments] = useState<
		{
			open_enrollment: OpenEnrollment & {
				plan: Plan;
			};
		}[]
	>([]);
	const [alwaysOpenEnrollments, setAlwaysOpenEnrollments] = useState<Plan[]>([]);
	const [buttonCaption, setButtonCaption] = useState<PlanNavigationMap>({
		// "Health Plan": {
		// 	nextPlan: "",
		// 	prevPlan: ""
		// },
		// "Clinic Card": {
		// 	nextPlan: "",
		// 	prevPlan: ""
		// },
		// "Group Short Term Disability": {
		// 	nextPlan: "",
		// 	prevPlan: ""
		// },
		// "Group Long Term Disability(Class 1)": {
		// 	nextPlan: "",
		// 	prevPlan: ""
		// },
		// "Group Long Term Disability(Class 2)": {
		// 	nextPlan: "",
		// 	prevPlan: ""
		// },
		// KSOP: {
		// 	nextPlan: "",
		// 	prevPlan: ""
		// },
		// "Helping Our Own": {
		// 	nextPlan: "",
		// 	prevPlan: ""
		// },
		// "Christmas Club Election": {
		// 	nextPlan: "",
		// 	prevPlan: ""
		// },
		// "Group Life Insurance": {
		// 	nextPlan: "",
		// 	prevPlan: ""
		// }
	});

	const [submittedEnrollment, setSubmittedEnrollment] = useState<any>(null); // {planName:status}

	const [enrollmentStatus, setEnrollmentStatus] = useState<EnrollmentStatusV2 | null>(null);
	const [value, setValue] = useState<string>();
	const [overallPremiums, setOverallPremiums] = useState<OverallPremiums[]>([]);
	const [dependents, setDependents] = useState<Member[]>([]);
	const [totalPremium, setTotalPremium] = useState(0.0);
	const location = useLocation();
	const { theme } = useContext(ThemeContext);
	const { member } = useContext(AuthContext);
	const { paycheck } = useContext(PaycheckContext);
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	const height = screen.height;
	const [showOverallPremium, setShowOverallPremium] = useState(true);
	const history = useHistory();
	const [currentStage, setCurrentStage] = useState(0);

	const { eligiblity } = useContext(EligibleDependentContext);

	const [previousEnrollments, setPreviousEnrollments] = useState<EnrollmentSchema[]>([]);

	const [eligiblityDialogProps, setEligiblityDialogProps] = useState<any>({
		openDialog: false,
		handleCloseEligiblityDialog: () =>
			setEligiblityDialogProps(
				Object.assign({}, eligiblityDialogProps, {
					openDialog: false
				})
			),
		eligibleDependents: [],
		ineligibleDependents: [],
		ineligibleRelationshipDependents: [],
		groupPlanName: "Health Plan"
	});

	const overallPremiumChipColor = {
		SUBMITTED: {
			background_color: "#d5e5d9",
			text_color: "#4cb464"
		},
		CURRENT: {
			background_color: "#f0ebc5",
			text_color: "#c9b30c"
		},
		WAIVED: {
			background_color: "#f7e9e9",
			text_color: "#eb2a2a"
		}
	};

	const speedDialActions = [
		// eslint-disable-next-line prettier/prettier
		{
			name: <div className="tooltip-speed-dial">Download&nbsp;Brochure</div>,
			icon: <DownloadIcon />,
			actionName: "download_brochure"
		},
		{
			name: <div className="tooltip-speed-dial">Email&nbsp;Brochure</div>,
			icon: <AttachEmailIcon />,
			actionName: "email_brochure"
		}
	];
	const [speedDialOpen, setSpeedDialOpen] = useState(true);

	const handleOpen = () => setSpeedDialOpen(true);

	const handleClose = () => setSpeedDialOpen(false);

	const initialVisitedPlans = useCallback(() => {
		if (corePlansForEmployeeClassSpecific && corePlansForEmployeeClassSpecific.length > 0) {
			corePlansForEmployeeClassSpecific.sort((a, b) => a.plan_order - b.plan_order);
			setVisitedPlans([corePlansForEmployeeClassSpecific[0].plan_name]);
		}
	}, [corePlansForEmployeeClassSpecific]);
	const handleToggle = () => {
		setTogglePlan(!togglePlan);
	};

	// Core plans routed to CommonForm need the VEB shape (key order included —
	// dynamicPremiumCalculation's lookup signature depends on it).
	const vebShapedCorePlans = useMemo(
		() =>
			corePlansForEmployeeClassSpecific.map((plan) => (plan.same_as_veb_structure ? toVEBPlanShape(plan) : plan)),
		[corePlansForEmployeeClassSpecific]
	);

	const handleChange = useCallback(
		(event: React.SyntheticEvent<Element, Event>, newValue: string) => {
			setActiveTab(newValue);
			setValue(newValue);
			deleteCurrentEnrollment();
			console.log("tabbbbb", newValue);

			const _enrollmentVisitedArray: string[] = [];

			sortedPlans.forEach((elememt, index) => {
				// paycheck?.employee_class === "FT - Full Time"
				// 	? elememt !== "Clinic Card" || index !== 1
				// 		? _enrollmentVisitedArray.push(elememt)
				// 		: null
				// 	: paycheck?.employee_class === "PT - Part Time"
				// 	? elememt !== "Health Plan" || index !== 0
				// 		? _enrollmentVisitedArray.push(elememt)
				// 		: null
				// 	:
				_enrollmentVisitedArray.push(elememt.plan_name);
			});

			_enrollmentVisitedArray.forEach((element, index) => {
				if (element === newValue) {
					const selectedRange = _enrollmentVisitedArray.slice(0, index + 1);
					setVisitedPlans([...selectedRange]);
				}
			});
		},
		[deleteCurrentEnrollment, sortedPlans, paycheck]
	);
	const handleChangePlanButtonClick = useCallback(
		(direction: string) => {
			const currentPlanName = urlSearchParams.get("step");
			if (!currentPlanName || !enrollmentStatus || !corePlansForEmployeeClassSpecific?.length) return;

			// Find the current plan based on its plan_name
			const currentPlan = corePlansForEmployeeClassSpecific.find((p) => p.plan_name === currentPlanName);
			if (!currentPlan) return;

			const currentOrder = currentPlan.plan_order;
			let targetPlan: Plan | undefined;

			if (direction === "FORWARD") {
				// Go to the next higher plan_order that is either open or always open
				for (const plan of sortedPlans) {
					if (plan.plan_order <= currentOrder) continue;
					if (
						enrollmentStatus[plan.plan_name as keyof EnrollmentStatus]?.openEnrollment === "OPENED" ||
						plan.is_always_open
					) {
						targetPlan = plan;
						break;
					}
				}
			} else if (direction === "BACKWARD") {
				// Go to the previous lower plan_order that is open or always open
				for (let i = sortedPlans.length - 1; i >= 0; i--) {
					const plan = sortedPlans[i];
					if (plan.plan_order >= currentOrder) continue;
					if (
						enrollmentStatus[plan.plan_name as keyof EnrollmentStatus]?.openEnrollment === "OPENED" ||
						plan.is_always_open
					) {
						targetPlan = plan;
						break;
					}
				}
			} else {
				console.warn("Invalid direction passed:", direction);
				return;
			}

			if (!targetPlan) return;

			//  Navigate using plan_name for routing (hybrid part)
			history.push(`?step=${targetPlan.plan_name}&stage=0`);
			setActiveTab(targetPlan.plan_name);
			setValue(targetPlan.plan_name);
			// console.log("tabbbbbb 2", targetPlan);

			//  Track visited plans using plan_name
			setVisitedPlans((prev) => {
				if (direction === "BACKWARD") {
					const targetIndex = prev.indexOf(targetPlan?.plan_name);
					if (targetIndex !== -1) {
						return prev.slice(0, targetIndex + 1);
					}
					return [...prev, targetPlan?.plan_name];
				}
				if (!prev.includes(targetPlan?.plan_name)) {
					const selectedPlanRange = sortedPlans
						.slice(0, sortedPlans.findIndex((p) => p.plan_name === targetPlan?.plan_name) + 1)
						.map((p) => p.plan_name);
					return [...new Set([...prev, ...selectedPlanRange])];
					//
					// return [...prev, targetPlan?.plan_name];
				}
				return prev;
			});

			//  Update button captions dynamically
			// setButtonCaption((prev) => ({
			// 	...prev,
			// 	[currentPlanName]: {
			// 		...(prev as any)[currentPlanName],
			// 		nextPlan: direction === "FORWARD" ? targetPlan!.plan_name : undefined,
			// 		prevPlan: direction === "BACKWARD" ? targetPlan!.plan_name : undefined
			// 	}
			// }));
		},
		[corePlansForEmployeeClassSpecific, enrollmentStatus, history, urlSearchParams, sortedPlans]
	);

	const getSortedPlans = useCallback(() => {
		if (corePlansForEmployeeClassSpecific && corePlansForEmployeeClassSpecific.length > 0) {
			setSortedPlans(corePlansForEmployeeClassSpecific.sort((a, b) => a.plan_order - b.plan_order));
		}
	}, [corePlansForEmployeeClassSpecific]);

	const setButtonCaptionForForwardAndBackwardMovement = useCallback(() => {
		const _buttonCaption: any = {};

		sortedPlans.forEach((plan, index) => {
			_buttonCaption[plan.plan_name] = {
				nextPlan: index < sortedPlans.length - 1 ? sortedPlans[index + 1].plan_name : "",
				prevPlan: index > 0 ? sortedPlans[index - 1].plan_name : ""
			};
		});

		setButtonCaption(_buttonCaption);
	}, [sortedPlans]);

	const getEnrollmentStatus = useCallback(
		(
			planName: string,
			enrollments: any,
			openEnrollments: {
				open_enrollment: OpenEnrollment & {
					plan: Plan;
				};
			}[]
		): {
			status: {
				enrollment: Status;
				openEnrollment: Status;
			};
			openEnrollmentByPlanItem: {
				[key: string]: OpenEnrollment & {
					plan: Plan;
				};
			} | null;
		} => {
			let enrollment: Status = "CLOSED";

			for (let enrollmentIdx = 0; enrollmentIdx < enrollments.length; enrollmentIdx++) {
				if (enrollments[enrollmentIdx]?.plan_name === planName) {
					enrollment = enrollments[enrollmentIdx].enrollment_status;
					break;
				}
			}
			let openEnrollment: Status = "CLOSED";
			let openEnrollmentByPlanItem: {
				[key: string]: OpenEnrollment & {
					plan: Plan;
				};
			} | null = null;
			for (let openEnrollmentIdx = 0; openEnrollmentIdx < openEnrollments.length; openEnrollmentIdx++) {
				if (openEnrollments[openEnrollmentIdx].open_enrollment.plan.plan_name === planName) {
					openEnrollment = "OPENED";

					openEnrollmentByPlanItem = {
						[planName]: openEnrollments[openEnrollmentIdx].open_enrollment
					};
					break;
				}
			}
			console.log("_openEnrollmentByPlan===============>", openEnrollmentByPlanItem);
			return {
				status: {
					enrollment,
					openEnrollment
				},
				openEnrollmentByPlanItem
			};
		},
		[]
	);

	const getActiveEnrollmentStatus = useCallback(
		(activeEnrollments: EnrollmentSchema[], corePlansForEmployeeClassSpecific: Plan[]) => {
			const _activeEnrollmentStatus: any = {};

			corePlansForEmployeeClassSpecific?.forEach((plan) => {
				_activeEnrollmentStatus[plan.plan_name] = false;
			});

			activeEnrollments?.forEach(({ plan_name }) => {
				if (plan_name && plan_name in _activeEnrollmentStatus) {
					_activeEnrollmentStatus[plan_name] = true;
				}
			});

			setActiveEnrollmentStatus(Object.assign({}, _activeEnrollmentStatus));
		},
		[]
	);
	// console.log("enrollments--", enrollments);
	// console.log("activeEnrollments--", activeEnrollments);
	// console.log("activeEnrollmentStatus--", activeEnrollmentStatus)
	const getEnrollmentInitData = useCallback(
		async (resetPlanTabs = true) => {
			if (!resetPlanTabs) return;
			const {
				openEnrollments,
				dependents,
				enrollments,
				activeEnrollments,
				alwaysOpenEnrollments,
				corePlansForEmployeeClassSpecific,
				previousEnrollments
			} = await trackPromise(api.pages.getEnrollmentInitData());

			console.log("corePlansForEmployeeClassSpecific=====>", corePlansForEmployeeClassSpecific);

			getActiveEnrollmentStatus(activeEnrollments, corePlansForEmployeeClassSpecific);
			setOpenEnrollments(Object.assign([], openEnrollments));
			setAlwaysOpenEnrollments(Object.assign([], alwaysOpenEnrollments));
			setCorePlansForEmployeeClassSpecific(Object.assign([], corePlansForEmployeeClassSpecific));

			if (enrollments.length > 0) {
				console.log("enrollments=====>", enrollments, alwaysOpenEnrollments);
				setEnrollments(Object.assign([], enrollments));
			}
			if (activeEnrollments.length > 0) {
				setActiveEnrollments(Object.assign([], activeEnrollments));
			}

			setPreviousEnrollments(Object.assign([], previousEnrollments ?? []));

			// DYNAMIC INITIALIZATION
			let _enrollmentStatus: EnrollmentStatusV2 = {};
			let _openEnrollmentByPlan: OpenEnrollmentByPlanV2 = {};

			corePlansForEmployeeClassSpecific?.forEach((plan: any) => {
				const planName = plan.plan_name;
				const isAlwaysOpen = !!plan.is_always_open;

				_enrollmentStatus[planName] = {
					enrollment: isAlwaysOpen ? "OPENED" : "CLOSED",
					openEnrollment: isAlwaysOpen ? "OPENED" : "CLOSED"
				};
				console.log("isAlwaysOpen=========>", _enrollmentStatus);

				_openEnrollmentByPlan[planName] = null;
			});

			// Merge backend open enrollment data
			Object.entries(_enrollmentStatus).forEach(([planName]) => {
				const { status, openEnrollmentByPlanItem } = getEnrollmentStatus(
					planName,
					enrollments,
					openEnrollments
				);
				console.log("openEnrollmentByPlanItem=========>", openEnrollmentByPlanItem);
				_enrollmentStatus = { ..._enrollmentStatus, [planName]: status };
				if (openEnrollmentByPlanItem !== null) {
					_openEnrollmentByPlan = {
						..._openEnrollmentByPlan,
						...openEnrollmentByPlanItem
					};
				}
			});
			console.log("_openEnrollmentByPlan===============>", _openEnrollmentByPlan);
			setOpenEnrollmentByPlan(Object.assign({}, _openEnrollmentByPlan));
			setEnrollmentStatus(Object.assign({}, _enrollmentStatus));
			setDependents(Object.assign([], dependents));

			setHasSetPlanTabs(true);
			onInitComplete?.();
		},
		[getActiveEnrollmentStatus, getEnrollmentStatus, paycheck?.employee_class, onInitComplete]
	);

	const initNextOfCurrentPlans = useCallback(() => {
		if (paycheck?.employee_class === "FT - Full Time") {
			const nextCurrentPlanOpenEnrollment: NextCurrentPlanOpenEnrollment = coreEnrollmentNext;
			delete nextCurrentPlanOpenEnrollment["Clinic Card"];
			nextCurrentPlanOpenEnrollment["Health Plan"] = "Group Short Term Disability";
			setNextOfCurrentPlan(nextCurrentPlanOpenEnrollment);
		} else if (paycheck?.employee_class === "PT - Part Time") {
			const nextCurrentPlanOpenEnrollment: NextCurrentPlanOpenEnrollment = coreEnrollmentNext;
			delete nextCurrentPlanOpenEnrollment["Health Plan"];
			setNextOfCurrentPlan(nextCurrentPlanOpenEnrollment);
		} else if (paycheck?.employee_class === "PTIN - Part Time Insurance Eligible") {
			const nextCurrentPlanOpenEnrollment: NextCurrentPlanOpenEnrollment = coreEnrollmentNext;
			nextCurrentPlanOpenEnrollment["Health Plan"] = "Clinic Card";
			setNextOfCurrentPlan(nextCurrentPlanOpenEnrollment);
		}
	}, [paycheck?.employee_class]);

	const handleOverallPremiumClick = () => {
		setShowOverallPremium((prevShowOverallPremium: boolean) => !prevShowOverallPremium);
	};

	//Old code
	// const getOverallPremium = useCallback(() => {
	// 	const _overallPremiums: any[] = [];
	// 	let submittedEnrollments: any[] = [];
	// 	let waivedEnrollments: any[] = [];
	// 	const _activeEnrollmentsPlanName: any[] = [];
	// 	const _overallPremiumsPayload: any[] = [];

	// 	submittedEnrollments = enrollments.filter((eachEnrollment: any) => {
	// 		return eachEnrollment.enrollment_status === "SUBMITTED";
	// 		// return eachEnrollment;
	// 	});
	// 	// if (enrollmentStatus?.["Helping Our Own"].enrollment === "CLOSED") {
	// 	// 	_activeEnrollmentsPlanName.push(enrollmentStatus["Helping Our Own"]);
	// 	// 	_overallPremiumsPayload.push({
	// 	// 		base_plan_name: "Helping Our Own",
	// 	// 		total_premium: 5,
	// 	// 		enrollment_status: "SUBMITTED"
	// 	// 	});
	// 	// }

	// 	submittedEnrollments.forEach((submittedEnrollment: any) => {
	// 		// _activeEnrollmentsPlanName.push(submittedEnrollment.base_plan_name);
	// 		_overallPremiumsPayload.push(submittedEnrollment);
	// 	});

	// 	waivedEnrollments = enrollments.filter((eachEnrollment: any) => {
	// 		return eachEnrollment.enrollment_status === "WAIVED";
	// 	});
	// 	const pushedWaivedPlanNames: string[] = [];
	// 	waivedEnrollments.forEach((waivedEnrollment: any) => {
	// 		const { base_plan_name } = waivedEnrollment;
	// 		if (
	// 			_activeEnrollmentsPlanName.includes(base_plan_name) === false &&
	// 			pushedWaivedPlanNames.includes(base_plan_name) === false
	// 		) {
	// 			_overallPremiumsPayload.push(waivedEnrollment);
	// 			pushedWaivedPlanNames.push(base_plan_name);
	// 		}
	// 	});

	// 	let _totalPremium = 0;
	// 	console.log("premium======>", _overallPremiumsPayload);
	// 	_overallPremiumsPayload.map((enrollment: EnrollmentSchema) => {
	// 		const { base_plan_name, enrollment_status, total_premium } = enrollment;
	// 		console.log("this is the overall premium", base_plan_name, enrollment_status, total_premium);
	// 		if (base_plan_name !== currentEnrollment?.plan_name) {
	// 			_overallPremiums.push({
	// 				plan_name: base_plan_name,
	// 				premium_amount: total_premium,
	// 				status: enrollment_status
	// 			});
	// 			_totalPremium += total_premium;
	// 		}
	// 	});
	// 	setTotalPremium(_totalPremium);
	// 	console.log("premium======> 22", _overallPremiums);
	// 	setOverallPremiums(Object.assign([], _overallPremiums));
	// }, [currentEnrollment, enrollments]);

	const getOverallPremium = useCallback(() => {
		const _overallPremiums: any[] = [];
		const _overallPremiumsPayload: any[] = [];

		let submittedEnrollments: any[] = [];
		let waivedEnrollments: any[] = [];

		let submittedActiveEnrollments: any[] = [];
		let waivedActiveEnrollments: any[] = [];

		// 👉 From enrollments
		submittedEnrollments = enrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "SUBMITTED";
		});

		waivedEnrollments = enrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "WAIVED";
		});

		// 👉 From activeEnrollments
		submittedActiveEnrollments = activeEnrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "ACTIVE";
		});

		waivedActiveEnrollments = activeEnrollments.filter((eachEnrollment: any) => {
			return eachEnrollment.enrollment_status === "WAIVED";
		});

		const pushedPlanNames: string[] = [];

		// ✅ Submitted from enrollments
		submittedEnrollments.forEach((submittedEnrollment: any) => {
			const { base_plan_name } = submittedEnrollment;

			if (pushedPlanNames.includes(base_plan_name) === false) {
				_overallPremiumsPayload.push(submittedEnrollment);
				pushedPlanNames.push(base_plan_name);
			}
		});

		// ✅ Submitted from activeEnrollments (FIXED)
		submittedActiveEnrollments.forEach((submittedEnrollment: any) => {
			const { base_plan_name } = submittedEnrollment;

			if (pushedPlanNames.includes(base_plan_name + "_active") === false) {
				_overallPremiumsPayload.push(submittedEnrollment);
				pushedPlanNames.push(base_plan_name + "_active");
			}
		});

		// ✅ Waived from enrollments
		waivedEnrollments.forEach((waivedEnrollment: any) => {
			const { base_plan_name } = waivedEnrollment;

			if (pushedPlanNames.includes(base_plan_name) === false) {
				_overallPremiumsPayload.push(waivedEnrollment);
				pushedPlanNames.push(base_plan_name);
			}
		});

		// ✅ Waived from activeEnrollments (FIXED)
		waivedActiveEnrollments.forEach((waivedEnrollment: any) => {
			const { base_plan_name } = waivedEnrollment;

			if (pushedPlanNames.includes(base_plan_name + "_active") === false) {
				_overallPremiumsPayload.push(waivedEnrollment);
				pushedPlanNames.push(base_plan_name + "_active");
			}
		});

		let _totalPremium = 0;

		_overallPremiumsPayload.forEach((enrollment: EnrollmentSchema) => {
			const { base_plan_name, enrollment_status, total_premium } = enrollment;

			if (base_plan_name !== currentEnrollment?.plan_name) {
				_overallPremiums.push({
					plan_name: base_plan_name,
					premium_amount: total_premium,
					status: enrollment_status
				});
				_totalPremium += total_premium;
			}
		});
		setTotalPremium(_totalPremium);
		setOverallPremiums(Object.assign([], _overallPremiums));
	}, [currentEnrollment, enrollments, activeEnrollments]);
	const handleEmailBrochurePost = useCallback(
		async (download = false) => {
			const step = urlSearchParams.get("step");
			if (!step || !member) {
				return;
			}

			const _planName = step;

			const { group_number, email, first_name, last_name, employee_SSN } = member;

			let planCodeForMailingBrochure: any = alwaysOpenEnrollments
				.filter((plan: any) => plan.plan_name === _planName)
				.map((plan: any) => plan.plan_code);

			if (planCodeForMailingBrochure.length === 0) {
				planCodeForMailingBrochure = openEnrollments
					.filter((enrollment: any) => enrollment.open_enrollment?.plan?.plan_name === _planName)
					.map((enrollment: any) => enrollment.open_enrollment?.plan?.plan_code);
			}

			if (planCodeForMailingBrochure.length === 0) {
				planCodeForMailingBrochure = corePlansForEmployeeClassSpecific
					.filter((plan: any) => plan.plan_name === _planName)
					.map((plan: any) => plan.plan_code);
			}

			const payload: any = {
				email: email,
				group_number: group_number,
				type: ALL_PLANS.type.core,
				employee_class: paycheck?.employee_class,
				employee_SSN: employee_SSN,
				plan_name: _planName,
				subject: `Dear Employee: ${first_name} ${last_name}, Your plan brochure`
			};

			if (planCodeForMailingBrochure.length > 0) {
				payload.plan_code = planCodeForMailingBrochure[0];
			}

			if (download === true) {
				payload.download = true;
			}

			const response = await trackPromise(api.email.emailBrochureV2(payload));

			if (response?.status === 200) {
				if (download !== true) {
					alert("Email brochure has been successfully sent");
				} else {
					downloadBrochureFile(response.data.file.content, response.data.file.filename);
				}
			}
		},
		[
			urlSearchParams,
			member,
			alwaysOpenEnrollments,
			openEnrollments,
			corePlansForEmployeeClassSpecific,
			paycheck?.employee_class
		]
	);

	const handleDownloadBrochure = useCallback(() => {
		handleEmailBrochurePost(true);
	}, [handleEmailBrochurePost]);

	const handleGetCurrentEnrollmentBenefitDetailsMail = useCallback(async () => {
		const { group_number, SSN } = member;

		const currentEnrollmentQuery = {
			group_number,
			SSN
		};

		try {
			const response = await api.enrollment.getEnrollmentCurrentBenefitEmail(currentEnrollmentQuery);
			if (response) alert("Successfully the mail has been sent!");
		} catch (error) {
			alert("Eror:404Something went wrong!");
		}
	}, [member]);

	const currentStep = urlSearchParams.get("step")?.trim();

	const selectedPlanForStep = useMemo(
		() => corePlansForEmployeeClassSpecific.find((plan) => plan.plan_name === currentStep),
		[corePlansForEmployeeClassSpecific, currentStep]
	);

	// console.log("selectedPlanForStep---", selectedPlanForStep);

	const renderPlan = useCallback(() => {
		if (enrollmentStatus === null || openEnrollmentByPlan === null || activeEnrollmentStatus === undefined) {
			return;
		}

		const step = urlSearchParams.get("step")?.trim();
		const stage = urlSearchParams.get("stage");

		console.log("Rendering plan for step:", step, "stage:", stage);

		const selectedPlan = corePlansForEmployeeClassSpecific.find((plan) => plan.plan_name === step);
		// console.log("selected plan=====> 1111", selectedPlan);
		if (!step || !stage || !selectedPlan) return;

		// console.log("selectedPlan=========>", selectedPlan);

		const isAlwaysOpen = selectedPlan.is_always_open;
		const planStatus = enrollmentStatus[step as keyof EnrollmentStatus];
		const brandingStatus = isAlwaysOpen ? { enrollment: "OPENED", openEnrollment: "OPENED" } : planStatus;

		// fallback for always open plans
		const openEnrollmentForPlan = isAlwaysOpen
			? {
				plan: selectedPlan,
				group_number: selectedPlan.group_number,
				start_date: selectedPlan.start_date,
				end_date: selectedPlan.end_date || null,
				is_always_open: true,
				type: "ALWAYS_OPEN",
				open_enrollment_for: "ALL"
			}
			: openEnrollmentByPlan[step as keyof EnrollmentStatusV2];
		console.log(
			enrollmentStatus[step as keyof EnrollmentStatusV2].enrollment,
			"openEnrollmentForPlan===========>",
			openEnrollmentForPlan
		);
		// console.log(enrollments, "onenr", openEnrollments);
		if (!step || !stage || !selectedPlan) {
			return;
		}

		if (stage === "0") {
			if (
				(["ACTIVE", "REJECTED", "SUBMITTED", "WAIVED", "WAIVED - WAITING FOR APPROVAL"].includes(
					enrollmentStatus[step as keyof EnrollmentStatusV2].enrollment
				) &&
					openEnrollments &&
					enrollments) ||
				(submittedEnrollment && submittedEnrollment[step as keyof EnrollmentStatusV2])
			) {
				console.log("here", step);
				return (
					<PlanAcknowledgement
						openEnrollments={openEnrollments}
						enrollments={enrollments}
						planName={step as keyof EnrollmentStatusV2}
						selectedPlan={selectedPlan}
						submittedEnrollment={submittedEnrollment}
					/>
				);
			} else {
				console.log(
					"{enrollmentStatus[step as keyof EnrollmentStatus]}",
					openEnrollmentByPlan[step as keyof EnrollmentStatusV2]
				);
				console.log(
					"activeEnrollmentStatus[step as keyof EnrollmentStatus]",
					activeEnrollmentStatus[step as keyof EnrollmentStatusV2]
				);
				return (
					<DynamicPlanBranding
						// status={enrollmentStatus[step as keyof EnrollmentStatus]}
						status={
							selectedPlan.is_always_open
								? { enrollment: "OPENED", openEnrollment: "OPENED" }
								: enrollmentStatus[step as keyof EnrollmentStatusV2]
						}
						dependents={dependents}
						openEnrollment={openEnrollmentByPlan[step as keyof EnrollmentStatusV2]}
						getEnrollmentInitData={getEnrollmentInitData}
						changePlanProps={{
							handleChangePlanButtonClick: handleChangePlanButtonClick,
							buttonCaption: buttonCaption[step as string]
						}}
						isActiveEnrollment={activeEnrollmentStatus[step as keyof EnrollmentStatusV2]}
						corePlansForEmployeeClassSpecific={corePlansForEmployeeClassSpecific}
						selectedPlan={selectedPlan}
						setSubmittedEnrollment={setSubmittedEnrollment}
						member={member}
					/>
				);
			}
		} else if (stage === "1") {
			// console.log("selectedPlan=22222===========>", openEnrollmentForPlan, enrollmentStatus, step);
			// if (["ACTIVE", "REJECTED"].includes(enrollmentStatus[step as keyof EnrollmentStatusV2].enrollment)) {
			// console.log("here 2222", step);
			return selectedPlan.same_as_veb_structure ? (
				<CommonForm
					dependents={dependents}
					VEBOpenEnrollment={[openEnrollmentForPlan] as any}
					getVEBEnrollmentInitData={getEnrollmentInitData}
					planname={activeTab as string}
					stage={stage}
					planCode={selectedPlan.plan_code}
					isCore={true}
					corePlans={vebShapedCorePlans}
					openEnrollment={openEnrollmentForPlan as any}
					getEnrollmentInitData={getEnrollmentInitData}
					isActiveEnrollment={activeEnrollmentStatus[step as keyof EnrollmentStatusV2]}
					selectedPlan={selectedPlan}
					setSubmittedEnrollment={setSubmittedEnrollment}
					previousEnrollments={previousEnrollments}
				/>
			) : (
				<DynamicEnrollmentPlanForm
					dependents={dependents}
					// openEnrollment={openEnrollmentByPlan[step as keyof EnrollmentStatus]}
					openEnrollment={openEnrollmentForPlan}
					getEnrollmentInitData={getEnrollmentInitData}
					isActiveEnrollment={activeEnrollmentStatus[step as keyof EnrollmentStatusV2]}
					corePlansForEmployeeClassSpecific={corePlansForEmployeeClassSpecific}
					selectedPlan={selectedPlan}
					setSubmittedEnrollment={setSubmittedEnrollment}
					previousEnrollments={previousEnrollments}
				/>
			);
			// <DynamicEnrollmentPlanForm
			// 	dependents={dependents}
			// 	// openEnrollment={openEnrollmentByPlan[step as keyof EnrollmentStatus]}
			// 	openEnrollment={openEnrollmentForPlan}
			// 	getEnrollmentInitData={getEnrollmentInitData}
			// 	isActiveEnrollment={activeEnrollmentStatus[step as keyof EnrollmentStatusV2]}
			// 	corePlansForEmployeeClassSpecific={corePlansForEmployeeClassSpecific}
			// 	selectedPlan={selectedPlan}
			// 	setSubmittedEnrollment={setSubmittedEnrollment}
			// />
			// }
		} else if (stage === "2") {
			console.log("");
			return (
				<PlanAcknowledgement
					openEnrollments={openEnrollments}
					enrollments={enrollments}
					planName={step as keyof EnrollmentStatusV2}
					selectedPlan={selectedPlan}
					submittedEnrollment={submittedEnrollment}
				/>
			);
		}
	}, [
		submittedEnrollment,
		activeEnrollmentStatus,
		dependents,
		enrollmentStatus,
		enrollments,
		getEnrollmentInitData,
		openEnrollmentByPlan,
		openEnrollments,
		urlSearchParams,
		currentStage,
		previousEnrollments
	]);

	useEffect(() => {
		getEnrollmentInitData(true);

		initNextOfCurrentPlans();
	}, [getEnrollmentInitData, initNextOfCurrentPlans]);

	useEffect(() => {
		getOverallPremium();
	}, [getOverallPremium, enrollments]);

	useEffect(() => {
		if (hasSetPlanTabs === true) {
			if (planTabs && planTabs.length > 0) {
				setActiveTab(planTabs[0].plan_name);
			}
		}
	}, [hasSetPlanTabs, planTabs]);

	useEffect(() => {
		if (corePlansForEmployeeClassSpecific && corePlansForEmployeeClassSpecific.length > 0) {
			const sortedPlans = [...corePlansForEmployeeClassSpecific].sort((a, b) => a.plan_order - b.plan_order);
			initialVisitedPlans();
			setPlanTabs(
				sortedPlans
					// eslint-disable-next-line arrow-parens
					.map((plan) => ({ plan_name: plan.plan_name as Plans }))
			);
		}
	}, [corePlansForEmployeeClassSpecific]);

	useEffect(() => {
		if (currentEnrollment) {
			const _overallPremiums: any[] = [];
			let _totalPremium = 0;
			enrollments.forEach((VEBEnrollment: EnrollmentSchema) => {
				const { base_plan_name, premium_amount, enrollment_status } = VEBEnrollment;
				if (base_plan_name !== currentEnrollment?.plan_name) {
					_overallPremiums.push({
						plan_name: base_plan_name,
						premium_amount: premium_amount,
						status: enrollment_status
					});
					_totalPremium += premium_amount;
				}
			});
			setTotalPremium(() => Number((_totalPremium + currentEnrollment.premium_amount).toFixed(2)));
		}
	}, [currentEnrollment, enrollments]);

	useEffect(() => {
		if (activeTab) {
			history.push("?step=" + activeTab + "&stage=0");
		}
	}, [activeTab, history]);

	useEffect(() => {
		// // console.log("i am running", urlSearchParams);
		if (sortedPlans.length > 0) {
			setButtonCaptionForForwardAndBackwardMovement();
		}
	}, [sortedPlans]);

	useEffect(() => {
		if (
			!urlSearchParams ||
			urlSearchParams == undefined ||
			urlSearchParams.get("step") == undefined ||
			!urlSearchParams.get("step")
		) {
			if (activeTab) {
				history.push("?step=" + activeTab + "&stage=0");
			} else {
				if (hasSetPlanTabs === true) {
					if (planTabs && planTabs.length > 0) {
						setActiveTab(planTabs[0].plan_name);
					}
				}
			}
		}
	}, [activeTab, hasSetPlanTabs, history, planTabs, urlSearchParams, visitedPlans]);

	// // console.log(urlSearchParams, "___need_state : activeTab", activeTab, "\nVisited", visitedPlans);

	// // console.log(urlSearchParams, "___need_state : activeTab", activeTab, "\nVisited", visitedPlans);

	useEffect(() => {
		if (urlSearchParams.get("stage") === "2") {
			// const stage = urlSearchParams.get("stage");
			// // console.log("Fetching enrollments for stage 2...");
			getEnrollmentInitData(false);
		}
	}, [urlSearchParams.get("stage")]);

	useEffect(() => {
		getSortedPlans();
	}, [getSortedPlans]);


	const handleEligibilityDialogOpen = useCallback(() => {
		const step = urlSearchParams.get("step");
		if (!activeTab) return;

		setEligiblityDialogProps({
			openDialog: true,
			handleCloseEligiblityDialog: () =>
				setEligiblityDialogProps((prev: any) => ({
					...prev,
					openDialog: false
				})),
			eligibleDependents: eligiblity.eligibleDependents,
			ineligibleRelationshipDependents: eligiblity.ineligibleRelationshipDependents,
			ineligibleDependents: eligiblity.ineligibleDependents,
			VEBPlanName: step
		});
	}, [eligiblity, eligiblityDialogProps, urlSearchParams]);

	// console.log("===openEnrollments===>", openEnrollments);
	// console.log("corePlansForEmployeeClassSpecific============================>", corePlansForEmployeeClassSpecific);
	// console.log("planTabs============================> 2", planTabs);
	// console.log("openEnrollmentByPlan==========>", openEnrollmentByPlan);
	// console.log("initial activeTab=================>", activeTab);
	// console.log("visitedPlans=================>", visitedPlans);
	// console.log("sortedPlans=================>", sortedPlans);
	// console.log("premium======> 333", overallPremiums);
	// console.log(overallPremiums, "enrollments=====>1111", activeEnrollments);

	//return <></>;
	return (
		<>
			<EligiblityDialog eligiblityDialogProps={eligiblityDialogProps} />
			<div className="enrollment">
				<Box
					className="box-container"
					sx={{
						flexGrow: 1,
						display: "flex",
						flexDirection: "row"
					}}
				>
					{/* ── Mobile: Show Plans trigger ── */}
					<div
						className={
							!togglePlan && width <= 820 ? "open-plan-list show-list" : "open-plan-list hide-list"
						}
						onClick={handleToggle}
					>
						<KeyboardArrowRightIcon className="arrow-icon" style={{ color: theme.button.color }} />
						Show Plans
					</div>

					{width <= 820 ? (
						/* ── Mobile Sidebar (Slide) ── */
						<Slide direction="right" in={togglePlan} mountOnEnter unmountOnExit>
							<div className="show-plan">
								<div className="close-plan-list show-list" onClick={handleToggle}>
									Hide Plans
								</div>
								<Tabs
									orientation="vertical"
									className="tabs-cotainer"
									style={{
										boxShadow:
											"rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
										borderTopLeftRadius: 20,
										borderTopRightRadius: 20,
										borderBottomLeftRadius: 20,
										borderBottomRightRadius: 20,
										color: theme.primary_color
									}}
									TabIndicatorProps={{
										style: {
											color: theme.primary_color,
											backgroundColor: theme.primary_color
										}
									}}
									value={value}
									onChange={handleChange}
								>
									{enrollmentStatus &&
										activeEnrollmentStatus &&
										sortedPlans.map((plan, index) => {
											console.log("Rendering tab for plan:", plan);
											const plan_name = plan.plan_name as Plans;
											const plan_order = plan.plan_order;
											// console.log("plan_order=====>", plan_name);

											// console.log("plan_name:", plan.plan_name, "isAlwaysOpen:", plan.is_always_open);

											const isAlwaysOpen = plan.is_always_open;
											const planStatus = enrollmentStatus[plan_name as keyof EnrollmentStatus];
											const activeStatus =
												activeEnrollmentStatus[plan_name as keyof ActiveEnrollmentStatus];

											const planCount = corePlansForEmployeeClassSpecific.length;
											const tabHeight = Math.min(48 + planCount * 20, 60);

											return (
												<Tab
													key={index}
													className={
														activeTab === plan_name
															? visitedPlans.includes(plan_name)
																? "active-tab tracker"
																: "active-tab"
															: visitedPlans.includes(plan_name)
																? "active-tab tracker"
																: "active-tab"
													}
													style={{
														// height: (height - 500) / corePlansForEmployeeClassSpecific.length,
														height: tabHeight,
														color: activeTab === plan_name ? theme.primary_color : undefined
													}}
													value={plan_name}
													onClick={handleToggle}
													// label={
													// 	enrollmentStatus[plan_name as keyof EnrollmentStatus]?.enrollment ? (
													// 		<EnrollmentTabLabel
													// 			planName={plan_name}
													// 			status={
													// 				["Helping Our Own", "Christmas Club Election"].includes(
													// 					plan_name
													// 				)
													// 					? "OPENED"
													// 					: enrollmentStatus[plan_name as keyof EnrollmentStatus]
													// 							.enrollment
													// 			}
													// 			isOpenEnrollment={
													// 				["Helping Our Own", "Christmas Club Election"].includes(
													// 					plan_name
													// 				)
													// 					? true
													// 					: enrollmentStatus[plan_name as keyof EnrollmentStatus]
													// 							.openEnrollment === "OPENED"
													// 			}
													// 			isActiveEnrollment={
													// 				activeEnrollmentStatus[
													// 					plan_name as keyof ActiveEnrollmentStatus
													// 				]
													// 			}
													// 			carrier="Kemper"
													// 		/>
													// 	) : null
													// }
													label={
														planStatus?.enrollment || isAlwaysOpen ? (
															<EnrollmentTabLabel
																planName={plan_name}
																status={isAlwaysOpen ? "OPENED" : planStatus.enrollment}
																isOpenEnrollment={
																	isAlwaysOpen
																		? true
																		: planStatus.openEnrollment === "OPENED"
																}
																isActiveEnrollment={activeStatus}
																carrier="Kemper"
															/>
														) : null
													}
													{...a11yProps(0)}
												/>
											);
										})}
								</Tabs>
							</div>
						</Slide>
					) : (
						/* ── Desktop: Floating Sidebar + Toggle Button ── */
						<>
							{/* Sidebar wrapper */}
							<div className="floating-sidebar-wrapper">
								{/* The collapsible sidebar */}
								<div className={`floating-sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
									<Tabs
										orientation="vertical"
										className="tabs-container"
										style={{
											boxShadow:
												"rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
											borderTopLeftRadius: 20,
											borderTopRightRadius: 20,
											borderBottomLeftRadius: 20,
											borderBottomRightRadius: 20,
											color: theme.primary_color
										}}
										TabIndicatorProps={{
											style: {
												color: theme.primary_color,
												backgroundColor: theme.primary_color
											}
										}}
										value={value}
										onChange={handleChange}
									>
										{enrollmentStatus &&
											activeEnrollmentStatus &&
											sortedPlans.map((plan, index) => {
												// console.log("Rendering tab for plan:", plan);
												const plan_name = plan.plan_name as Plans;
												const plan_order = plan.plan_order;
												// console.log("plan_order=====>", plan_name);

												console.log("plan_name:", plan.plan_name);

												const isAlwaysOpen = plan.is_always_open;
												const planStatus =
													enrollmentStatus[plan_name as keyof EnrollmentStatus];
												const activeStatus =
													activeEnrollmentStatus[plan_name as keyof ActiveEnrollmentStatus];

												const planCount = corePlansForEmployeeClassSpecific.length;
												const tabHeight = Math.min(48 + planCount * 20, 60);

												return (
													<Tab
														key={index}
														className={
															activeTab == plan_name
																? visitedPlans.includes(plan_name)
																	? "active-tab tracker"
																	: "active-tab"
																: visitedPlans.includes(plan_name)
																	? "active-tab tracker"
																	: "active-tab"
														}
														style={{
															// height: (height - 500) / corePlansForEmployeeClassSpecific.length,
															height: tabHeight,
															color:
																activeTab == plan_name ? theme.primary_color : undefined
														}}
														value={plan_name}
														// label={
														// 	enrollmentStatus[plan_name as keyof EnrollmentStatus]?.enrollment ? (
														// 		<EnrollmentTabLabel
														// 			planName={plan_name}
														// 			status={
														// 				["Helping Our Own", "Christmas Club Election"].includes(
														// 					plan_name
														// 				)
														// 					? "OPENED"
														// 					: enrollmentStatus[plan_name as keyof EnrollmentStatus]
														// 							.enrollment
														// 			}
														// 			isOpenEnrollment={
														// 				["Helping Our Own", "Christmas Club Election"].includes(
														// 					plan_name
														// 				)
														// 					? true
														// 					: enrollmentStatus[plan_name as keyof EnrollmentStatus]
														// 							.openEnrollment === "OPENED"
														// 			}
														// 			isActiveEnrollment={
														// 				activeEnrollmentStatus[
														// 					plan_name as keyof ActiveEnrollmentStatus
														// 				]
														// 			}
														// 			carrier="Kemper"
														// 		/>
														// 	) : null
														// }
														label={
															planStatus?.enrollment || isAlwaysOpen ? (
																<EnrollmentTabLabel
																	planName={plan_name}
																	status={
																		isAlwaysOpen ? "OPENED" : planStatus.enrollment
																	}
																	isOpenEnrollment={
																		isAlwaysOpen
																			? true
																			: planStatus.openEnrollment === "OPENED"
																	}
																	isActiveEnrollment={activeStatus}
																	carrier="Kemper"
																/>
															) : null
														}
														{...a11yProps(0)}
													/>
												);
											})}
									</Tabs>
								</div>

								{/* Toggle button — always visible, tickles when collapsed */}
								<div
									className={`floating-toggle-btn ${sidebarCollapsed ? "collapsed" : ""}`}
									onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
								>
									<KeyboardArrowRightIcon />
								</div>
							</div>

							{/* Main content — fills remaining width and full height */}
							<div
								className={`form-container ${sidebarCollapsed ? "sidebar-collapsed" : "sidebar-expanded"
									}`}
							>
								{renderPlan()}
							</div>
						</>
					)}
				</Box>

				{/* Overall Premium Draggable Box */}
				{showOverallPremium ? (
					<Draggable>
						<div className="draggable-premium-box">
							<div>
								<div
									className={"top-bar-expand"}
									style={{ backgroundColor: theme.button.background_color }}
								>
									<div className="header" style={{ color: theme.button.color }}>
										Overall Premium (Current OE)
									</div>
									<div className={"icon-expand"}>
										<IconButton onClick={handleOverallPremiumClick}>
											<KeyboardArrowRightIcon style={{ color: theme.button.color }} />
										</IconButton>
									</div>
								</div>
							</div>
							<div>
								<div
									style={{
										backgroundColor: "#e3e1e1",
										padding: "1rem",
										display: "flex",
										fontWeight: "bold",
										alignItems: "center",
										gap: "20%"
									}}
								>
									<div className="header" style={{ color: "#242424", flex: "1" }}>
										{/* <span>VEB</span> */}
										<span>Group&nbsp;Plan(s)</span>
									</div>

									<div className="header" style={{ fontSize: "1rem", marginLeft: "2rem", flex: "3" }}>
										Premium&nbsp;($)
									</div>
									<div
										className="header"
										style={{ color: "#242424", marginRight: "12rem", flex: "1" }}
									>
										Status
									</div>
								</div>
							</div>
							<TableContainer
								component={Paper}
								style={{ zIndex: 99999, maxHeight: "300px", overflowY: "auto" }}
							>
								<Table sx={{ minWidth: 300 }} aria-label="customized table">
									{/* <TableHead>
										<TableRow>
											<StyledTableCell>
												<span className="premium-table-header">Plan</span>
											</StyledTableCell>
											<StyledTableCell align="right">
												<span className="premium-table-header">Premium&nbsp;($)</span>
											</StyledTableCell>
											<StyledTableCell align="right">
												<span className="premium-table-header">Status</span>
											</StyledTableCell>
										</TableRow>
									</TableHead> */}
									<TableBody>
										{overallPremiums.map((overallPremium: OverallPremiums, index: number) => (
											<StyledTableRow key={index}>
												<StyledTableCell component="th" scope="row">
													{overallPremium.plan_name}
												</StyledTableCell>
												<StyledTableCell align="right">
													{overallPremium.premium_amount.toFixed(2)}
												</StyledTableCell>
												{overallPremium.status ? (
													<StyledTableCell align="right">
														<Chip
															label={initCapitalize(overallPremium.status)}
															style={{
																backgroundColor: `${overallPremium.status === "SUBMITTED"
																	? overallPremiumChipColor.SUBMITTED
																		.background_color
																	: overallPremium.status === "WAIVED"
																		? overallPremiumChipColor.WAIVED
																			.background_color
																		: null
																	}`,
																color: `${overallPremium.status === "SUBMITTED"
																	? overallPremiumChipColor.SUBMITTED.text_color
																	: overallPremium.status === "WAIVED"
																		? overallPremiumChipColor.WAIVED.text_color
																		: null
																	}`,
																fontWeight: "700"
															}}
														/>
													</StyledTableCell>
												) : null}
											</StyledTableRow>
										))}
										{currentEnrollment ? (
											<StyledTableRow>
												<StyledTableCell component="th" scope="row">
													{currentEnrollment.plan_name}
												</StyledTableCell>
												<StyledTableCell align="right">
													{currentEnrollment.premium_amount}
												</StyledTableCell>
												<StyledTableCell align="right">
													<Chip
														label={initCapitalize(currentEnrollment.status)}
														style={{
															backgroundColor:
																overallPremiumChipColor.CURRENT.background_color,
															color: overallPremiumChipColor.CURRENT.text_color,
															fontWeight: "700"
														}}
													/>
												</StyledTableCell>
											</StyledTableRow>
										) : null}
									</TableBody>
								</Table>
							</TableContainer>
							<div>
								<div
									style={{
										backgroundColor: "#e3e1e1",
										padding: "0.3rem",
										display: "flex",
										fontWeight: "bold",
										alignItems: "center",
										gap: "20%"
									}}
								>
									<div className="header" style={{ color: "#242424", marginLeft: "1rem" }}>
										TOTAL AMOUNT
									</div>

									<div className="show-premium" style={{ fontSize: "1.3rem" }}>
										{dollarize(Number(totalPremium.toFixed(2))) + (currentEnrollment ? "*" : "")}
									</div>
								</div>
							</div>
						</div>
					</Draggable>
				) : (
					<Draggable axis="y">
						<div className="draggable-premium-box">
							<div>
								<div className={"top-bar"} style={{ backgroundColor: theme.button.background_color }}>
									<div className="header" style={{ color: theme.button.color }}>
										Overall Amount
									</div>
									<div className={"icon"}>
										<IconButton onClick={handleOverallPremiumClick}>
											<KeyboardArrowRightIcon style={{ color: theme.button.color }} />
										</IconButton>
									</div>
								</div>
							</div>
						</div>
					</Draggable>
				)}
			</div>

			{/* FABs — replicated from Enrollment (second) component */}
			<Tooltip title="Get Current Benefit Details">
				<Fab
					sx={{
						position: "fixed",
						bottom: 18,
						right: 156,
						bgcolor: theme.primary_color,
						"&:hover": { bgcolor: theme.primary_color }
					}}
					onClick={handleGetCurrentEnrollmentBenefitDetailsMail}
				>
					<EmailIcon style={{ color: "white" }} />
				</Fab>
			</Tooltip>

			{/* {urlSearchParams.get("step") !== "Christmas Club Election" ? ( */}
			<SpeedDial
				ariaLabel="SpeedDial tooltip example"
				sx={{ position: "fixed", bottom: 16, right: 16 }}
				icon={<SpeedDialIcon />}
				onOpen={handleOpen}
				onClose={handleClose}
				open={speedDialOpen}
				style={{ fontSize: "10px" }}
				FabProps={{
					sx: {
						bgcolor: theme.primary_color,
						"&:hover": {
							bgcolor: theme.primary_color
						}
					}
				}}
			>
				{speedDialActions.map((speedDialAction: any) => (
					<SpeedDialAction
						key={speedDialAction.name}
						icon={speedDialAction.icon}
						tooltipTitle={<div className="tooltip-speed-dial">{speedDialAction.name}</div>}
						tooltipOpen
						onClick={
							speedDialAction.actionName === "email_brochure"
								? handleEmailBrochurePost
								: // : () => downloadFile(Brochure)
								handleDownloadBrochure
						}
						style={{ fontSize: "10px" }}
					/>
				))}

				{urlSearchParams.get("stage") === "1" && !selectedPlanForStep?.is_always_open && (
					<SpeedDialAction
						icon={<DifferenceIcon />}
						tooltipTitle={<div className="tooltip-speed-dial">Check&nbsp;Eligibility</div>}
						tooltipOpen
						onClick={handleEligibilityDialogOpen}
						style={{ fontSize: "10px" }}
					/>
				)}
			</SpeedDial>
			{/* ) : null} */}
		</>
	);
};

export default DynamicEnrollment;
